import { VehicleTypes } from "../enquiry/enquiry-data"
import Utils from "../util/Utils"
/*
{
    "vendorName":"Lets Transport",
    "vehicles":[{"vehicle":"tataAce","numVehicles":2,"costPerVehicle":11178,"amount":22356}],
    "type":"origin","opin":"456006","dpin":"400707"
}
{
    "type":"destination","opin":"21237","dpin":"07021","cost":3737.15,"markup":373.72
}
*/
let USTransport = (props) => {
    let v = props.usTransportRec
    if(Array.isArray(props.usTransportRec)){
        if(props.usTransportRec.length==1){
            return <td style={{ width: '25rem' }}>
            <div>Transporter <strong>Forward Air</strong>.</div>
            <div style={{ whiteSpace: 'nowrap' }}>From Pin <strong>{v[0].opin} to {v[0].dpin}</strong> </div>
            <div style={{ whiteSpace: 'nowrap' }}>Cost <strong>{Utils.N(v[0].cost, 'USD')}. Mark-up {Utils.N(v[0].markup, 'USD')}</strong> </div>
        </td>
        }else{
            let k = []
            for (let i = 0; i < props.usTransportRec.length; i++) {
                let c = props.usTransportRec[i]
                k.push(
                    <td style={{ width: '25rem' }}>
        <div>Transporter <strong>Forward Air</strong>.</div>
        <div style={{ whiteSpace: 'nowrap' }}>From Pin <strong>{c.opin} to {c.dpin}</strong> </div>
        <div style={{ whiteSpace: 'nowrap' }}>Cost <strong>{Utils.N(c.cost, 'USD')}. Mark-up {Utils.N(c.markup, 'USD')}</strong> </div>
    </td>
                )
            }
            return k
        }
    }else{
        return <td style={{ width: '25rem' }}>
        <div>Transporter <strong>Forward Air</strong>.</div>
        <div style={{ whiteSpace: 'nowrap' }}>From Pin <strong>{v.opin} to {v.dpin}</strong> </div>
        <div style={{ whiteSpace: 'nowrap' }}>Cost <strong>{Utils.N(v.cost, 'USD')}. Mark-up {Utils.N(v.markup, 'USD')}</strong> </div>
    </td>
    }
}
let InstaTransport = (props) => {
    let v = props.instaTransportRec
    return <td style={{ width: '25rem' }}>
        <div>Transporter <strong>INSTA Freight</strong>.</div>
        <div style={{ whiteSpace: 'nowrap' }}>From Pin <strong>{v.opin} to {v.dpin}</strong> </div>
        <div style={{ whiteSpace: 'nowrap' }}>Cost <strong>{Utils.N(v.cost, 'EUR')}. Mark-up {Utils.N(v.markup, 'EUR')}</strong> </div>
    </td>
}
let DDTransport = (props) => {
    let v = props.ddTransportRec
    return <td style={{ width: '25rem' }}>
        <div>Transporter <strong>Done Deliveries</strong>.</div>
        <div style={{ whiteSpace: 'nowrap' }}>From Pin <strong>{v.opin} to {v.dpin}</strong> </div>
        <div style={{ whiteSpace: 'nowrap' }}>Cost <strong>{Utils.N(v.cost, 'EUR')}. Mark-up {Utils.N(v.markup, 'EUR')}</strong> </div>
    </td>
}
let IndiaTransport = (props) => {
    let v = props.vehicleRec
    let fields = new VehicleTypes().fields
    return <td>
        <div>From Pin <strong>{v.opin} to {v.dpin}</strong> </div>
        <table>
            <thead>
                <tr>
                    <th>Vendor</th>
                    <th>Vehicle Type</th>
                    <th># of Vehicles</th>
                    <th>Cost per vehicle</th>
                </tr>
            </thead>
            <tbody>
                {
                    v.vehicles?.map(e => <tr>
                        <td>{e.vendorId}</td>
                        <td>{fields[e.vehicle]}</td>
                        <td>{e.numVehicles}</td>
                        <td>{Utils.N(e.costPerVehicle)}</td>
                    </tr>)
                }
            </tbody>
        </table>
    </td>
}
export {
    IndiaTransport
}
export default function BookingSchedule(props) {
    let e = props.booking.schedule
    let c = props.booking.contract
    /*return (
        <div>{JSON.stringify(e)}</div>
    )*/
   const setv = (i,j)=>{
    let l = i
    if(l==undefined || l.length==0){
        l=j
    }
    return l
   }
   let por = setv(e.por,c.portOfReceipt)
   let pol = setv(e.pol,c.portOfLoading)
   let pod = setv(e.pod,c.portOfDischarge)
   let fpod = setv(e.fpod,c.finalPlaceOfDelivery)
   let rep = setv(e.rep,c.reworkingPort)
    let isOriginIndia = false
    let isOriginUS = false
    let isOriginInsta = false
    let isOriginDD = false
    let isDestinationIndia = false
    let isDestinationUS = false
    let isDestinationInsta = false
    let isDestinationDD = false
    if (c.vehicleRec) {
        if (c.vehicleRec.type == 'origin') isOriginIndia = true
        else isDestinationIndia = true
    }
    if (c.usTransportRec) {
        if(Array.isArray(c.usTransportRec)){
            if (c.usTransportRec[0].type == 'origin') isOriginUS = true
            else isDestinationUS = true
        }else{
            if (c.usTransportRec.type == 'origin') isOriginUS = true
            else isDestinationUS = true
        }
    }
    if (c.instaTransportRec) {
        if (c.instaTransportRec.type == 'origin') isOriginInsta = true
        else isDestinationInsta = true
    }
    if (c.ddTransportRec) {
        if (c.ddTransportRec.type == 'origin') isOriginDD = true
        else isDestinationDD = true
    }
    return (
        <div style={{ padding: '1rem', backgroundColor: '#eee' }}>
            <table className='table is-full-width is-bordered' style={{ zoom: '0.8', }}>
                <thead>
                    <tr>
                        {
                            isOriginIndia || isOriginUS || isOriginInsta || isOriginDD ?
                            <>{
                                (isDestinationUS && c.usTransportRec.length>1)?
                                <>
                                {
                                    c.usTransportRec.map((e,i)=>{
                                        return  <th style={{ width: '5rem' }}>Transport-{i+1}</th>
                                    })
                                }
                                </>
                                : <th style={{ width: '5rem' }}>Transport</th>
                            }
                            </>
                                 : <></>
                        }
                        <th>Place of Receipt</th>
                        <th>Port of Loading</th>
                        <th>Re-working Port</th>
                        <th>Port of Discharge</th>
                        <th>Final POD</th>
                        {
                            c.shipmentType == 'Air' &&
                            <>
                                <th>DO Type</th>
                                <th>Chargeable Weight</th>
                            </>
                        }
                        {
                            c.shipmentType != 'Air' &&
                            <>
                                <th>Carrier</th>
                                <th>Consolidator</th>
                            </>
                        }
                        {
                            isDestinationIndia || isDestinationUS || isDestinationInsta ?
                            <>{
                                (isDestinationUS && c.usTransportRec.length>1)?
                                <>
                                {
                                    c.usTransportRec.map((e,i)=>{
                                        return <th >Transport-{i+1}</th>
                                    })
                                }
                                </>
                                :<th >Transport</th>
                            }
                            </>
                                 : <></>
                        }
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        {
                            isOriginIndia ?
                                <IndiaTransport vehicleRec={c.vehicleRec} /> : <></>
                        }
                        {
                            isOriginUS ?
                                <USTransport usTransportRec={c.usTransportRec} /> : <></>
                        }
                        {
                            isOriginInsta ?
                                <InstaTransport instaTransportRec={c.instaTransportRec} /> : <></>
                        }
                        {
                            isOriginDD ?
                                <DDTransport ddTransportRec={c.ddTransportRec} /> : <></>
                        }
                        <td>{por}</td>
                        <td>{pol}</td>
                        <td>{rep}</td>
                        <td>{pod}</td>
                        <td>{fpod}</td>
                        {
                            c.shipmentType == 'Air' &&
                            <>
                                <td>{c.doCaseType}</td>
                                <td>{c.chargeableWeight}</td>
                            </>
                        }
                        {
                            c.shipmentType != 'Air' &&
                            <>
                                <td>{e.CARRIER ? e.CARRIER : ''}</td>
                                <td>{e['CO-LOADER'] ? e['CO-LOADER'] : ''}</td>
                            </>
                        }
                        {
                            isDestinationIndia ?
                                <IndiaTransport vehicleRec={c.vehicleRec} /> : <></>
                        }
                        {
                            isDestinationUS ?
                                <USTransport usTransportRec={c.usTransportRec} /> : <></>
                        }
                        {
                            isDestinationInsta ?
                                <InstaTransport instaTransportRec={c.instaTransportRec} /> : <></>
                        }
                        {
                            isDestinationDD ?
                                <DDTransport ddTransportRec={c.ddTransportRec} /> : <></>
                        }
                    </tr>
                </tbody>
            </table>
        </div>
    )
}